import createAction from '../services/create-action';

export const UPDATE_USER_SETTINGS_REQUEST = 'userSettings/UPDATE_REQUEST';
export const UPDATE_USER_SETTINGS_SUCCESS = 'userSettings/UPDATE_SUCCESS';
export const UPDATE_USER_SETTINGS_FAILURE = 'userSettings/UPDATE_FAILURE';

export const updateUserSettingsRequest = createAction(UPDATE_USER_SETTINGS_REQUEST);
export const updateUserSettingsSuccess = createAction(UPDATE_USER_SETTINGS_SUCCESS);
export const updateUserSettingsFailure = createAction(UPDATE_USER_SETTINGS_FAILURE);

export const updateUserSettings = (userId, settings) => (dispatch, getState, { request }) => {
  dispatch(updateUserSettingsRequest(settings));

  const promise = request.put(`/_api/users/${userId}/settings`, settings);
  return promise
    .then(() => dispatch(updateUserSettingsSuccess(settings)), () => dispatch(updateUserSettingsFailure()))
    .then(() => promise);
};



// WEBPACK FOOTER //
// ./app/actions/update-user-settings.js